// Sizes a card button's hover pill to its caption. Shared by the art-books
// and calendar catalogs, like the buttons themselves (kss-card-buttons.css).
//
// A cart button's caption carries its price ("Add Digital · €89"), so its
// length changes from product to product; the View button's is set in
// Customize and can be anything from "View" to "Full details". Neither can
// have one fixed width. Measure the caption as the pointer arrives — the
// event runs before the :hover styles are recalculated, so the opening
// transition already heads for the right size — and hand the width to the
// CSS, which sizes the pill around it.
//
// Delegated from `document`, not bound to each button: facets.js replaces
// the product grid's markup on every filter or sort change, which would
// drop per-button listeners.
(function () {
  document.addEventListener('mouseover', function (event) {
    // Both kinds carry this class; a cart button carries its own as well.
    var button = event.target.closest && event.target.closest('.kss-book-card__view-btn');
    if (!button) return;
    var caption = button.querySelector('.kss-book-card__view-caption');
    if (caption) button.style.setProperty('--kss-caption-width', caption.scrollWidth + 'px');
  });
})();
